// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"4cdf2961","636":"81ab57b4"}[chunkId] + ".chunk.css";
};